export default __webpack_public_path__ + "static/2026ProspectusCover-85a3d860f7cb5b202d33b9f76aebb0d6.jpg";